export function validarTarjetas(tarjetas = []) {
  const errors = [];

  tarjetas.forEach((tarj, i) => {
    const importe = parseFloat(tarj.importe);
    if (
      importe > 0 ||
      tarj.ultimos4 ||
      tarj.lote ||
      tarj.cupon ||
      tarj.tipo_id ||
      tarj.banco_id ||
      tarj.marca_id
    ) {
      if (!tarj.tipo_id) errors.push(`Tarjeta ${i + 1}: falta el tipo`);

      if (!tarj.banco_id) errors.push(`Tarjeta ${i + 1}: falta el banco`);

      if (!tarj.marca_id) errors.push(`Tarjeta ${i + 1}: falta la marca`);

      if (
        !tarj.ultimos4 ||
        tarj.ultimos4.length !== 4 ||
        !/^\d{4}$/.test(tarj.ultimos4)
      ) {
        errors.push(`Tarjeta ${i + 1}: últimos 4 dígitos inválidos`);
      }

      if (!tarj.cupon || tarj.cupon.trim() === "") {
        errors.push(`Tarjeta ${i + 1}: falta el cupon`);
      }

      if (tarj.cupon.length !== 4) {
        errors.push(`Tarjeta ${i + 1}: El cupon debe tener 4 digitos`);
      }
      if (!tarj.lote || tarj.lote.trim() === "") {
        errors.push(`Tarjeta ${i + 1}: falta el lote`);
      }

      if (tarj.lote.length !== 3) {
        errors.push(`Tarjeta ${i + 1}: El lote debe tener 3 digitos`);
      }

      if (isNaN(importe) || importe <= 0) {
        errors.push(`Tarjeta ${i + 1}: el importe debe ser mayor a 0`);
      }
    }
  });

  return {
    isValid: errors.length === 0,
    errors,
  };
}
